import React, { Component } from 'react';
import { Table, Button, Icon, Divider, Modal, message } from 'antd';
import { connect } from 'react-redux';

import { getHomeBlockList, deleteHomeBlock } from '../../../../../../../actions';

class HomeBlockTable extends Component {
  componentWillMount() {
    this.props.getHomeBlockList();
  }

  columns = [{
    title: 'Tiêu đề',
    key: 'title',
    dataIndex: 'title',
    render: (_, record) => (
      <span>
        {record.title[0] && record.title[0].value}
      </span>
    ),
  }, {
    title: 'Url',
    key: 'url',
    dataIndex: 'title',
    render: (_, record) => (
      <span>
        {record.title[0] && record.title[0].url}
      </span>
    ),
  }, {
    title: 'Màu sắc',
    key: 'color',
    dataIndex: 'color',
    render: (text) => (
      <span style={{color: text || '#FB5422'}}>
        {text}
      </span>
    ),
  }, {
    title: 'Ưu tiên',
    key: 'position',
    dataIndex: 'position',
  }, {
    title: 'Tùy chỉnh',
    key: 'action',
    render: (text, record) => (
      <span>
        <a role='button' onClick={() => { this.handleEdit(record); }}><Icon type="edit" />{' '}Sửa</a>
        <Divider type="vertical" />
        <a role='button' onClick={() => { this.handleDelete(record._id); }}><Icon type="delete" />{' '}Xóa</a>
      </span>
    ),
  }];

  createMenu = () => {
    this.props.showEditor();
  }

  handleEdit = (record) => {
    this.props.showEditor(record);
  }

  handleDelete = (key) => {
    Modal.confirm({
      title: 'Bạn chắc chắn xóa',
      onText: 'Xóa',
      okType: 'danger',
      cancleText: 'Hủy',
      onOk: () => {
        this.props.deleteHomeBlock({
          _id: key,
          response: {
            success: async () => {
              await this.props.getHomeBlockList();
              message.success('Xóa thành công');
            },
            failure: async (msg = 'Xóa không thành công') => {
              message.error(msg);
            },
          },
        });
      },
      onCancel: () => {

      },
    });
  }

  render() {
    const { loading, list } = this.props.homeBlock;

    return (
      <div>

        <p style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            type="primary"
            onClick={this.createMenu}
            style={{ marginTop: '10px' }}
          >
            <Icon type="file-add" />Tạo mới
          </Button>
        </p>

        <Table loading={loading} columns={this.columns} dataSource={list} />

        <p style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            type="primary"
            onClick={this.createMenu}
            style={{ marginTop: '10px' }}
          >
            <Icon type="file-add" />Tạo mới
          </Button>
        </p>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  homeBlock: state.homeBlock,
});

const mapDispatchToProps = {
  getHomeBlockList,
  deleteHomeBlock,
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeBlockTable);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Governance/HomePage/Tabs/HomeBlock/HomeBlockTable.js